import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { Database } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const SourceNode = ({ data, selected }: NodeProps) => {
    const path = data.path || data.filePath;
    const label = path ? path.split('/').pop() : 'Select...';

    return (
        <BaseNodeUI
            title={data.label || 'Source'}
            icon={Database}
            colorClass=""
            bgClass="bg-gradient-to-br from-teal-500 to-teal-700"
            selected={selected}
            isRunning={data?.executionStatus === 'Running'} executionStatus={data?.executionStatus}
            isTarget={true} // Allow inputs (e.g. from Email Trigger)
            rowsProcessed={data?.rowsAffected}
        />
    );
};

export default memo(SourceNode);
